import { ConnectSectionResponse, ConnectSectionRequest } from "./connect-launch.interface";
import { getResponseData } from "../../common/utils/api-utils";
import { getConnectLaunchUrlMagento } from "../../common/constants/shop-api";
import { getAuthenticationHeaders } from "../../common/utils/auth-utils";

export async function submitConnectSectionMagentoApiCall(requestBody: ConnectSectionRequest): Promise<ConnectSectionResponse> {
  const url = getConnectLaunchUrlMagento();
  return await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: getAuthenticationHeaders(),
      body: JSON.stringify(requestBody)
    })
  );
}
